<script>
		import {user, view, send_data} from "../client.svelte.js";
		import {perksToString} from "../core.js";
		import Sidebar from "../elements/Sidebar.svelte";

		const typeOrder = ['Weapon', 'Armor', 'jewelry', 'valuable', 'tool', 'accessoir', 'garment']
		const typeLabels = {Weapon: "Waffen", Armor: "Rüstungen", jewelry: "Schmuck", valuable: "Wertgegenstände",
		                    tool: "Werkzeuge", accessoir: "Hilfsmittel", garment: "Kleidung"}
		const storageKey = 'pentelion-rewards-grouped'

		let grouped = $state(read_grouped())

		let rewardItems = $derived(
			view.adventure.rewards
				.map(itemID => user.gearitems.get(itemID))
				.filter(item => item)
				.sort((a,b) => (a.name ?? "").localeCompare(b.name ?? "")) )
		let groups = $derived(
			(!grouped) ?
				((rewardItems.length > 0) ? [{label: "Alle Gegenstände", items: rewardItems}] : [])
			:	Object.entries(Object.groupBy(rewardItems, item => item.type ?? 'other'))
					.sort(([a], [b]) => rank(a) - rank(b))
					.map(([type, items]) => ({label: typeLabels[type] ?? "Sonstige", items})) )
    // $inspect(`REWARDS - groups`, groups)


		function rank(type) {
				const idx = typeOrder.indexOf(type)
				return (idx < 0) ? typeOrder.length : idx  }

		function read_grouped() {
				try { return localStorage.getItem(storageKey) !== 'false' }
				catch { return true }  }

		function set_grouped(value) {
				grouped = value
				try { localStorage.setItem(storageKey, String(value)) } catch {}  }

		function sum_of(items, attr) {
				return items.reduce((accum, item) => accum + (+item[attr] || 0) * (item.amount ?? 1), 0)  }

		function format_number(num) {
				return (+num || 0).toLocaleString('de-DE', {maximumFractionDigits: 2})  }

		function type_image(type) {
				return `/static/images/${(type ?? 'Accessoir').replace(/^./, c => c.toUpperCase())}.png`  }


		function add_item() {
				view.show_dialog('gearitem', {item: {ID: "_"}, mode: 'add'})  }

		function edit_item(item) {
				view.show_dialog('gearitem', {item: item, mode: 'chg'})  }

		async function delete_item(e, item) {
				e.stopPropagation()
				if (!confirm(`Soll der Gegenstand „${item.name}“ wirklich gelöscht werden?`))  return
				try {
						await send_data(`/gearitem/${item.ID}`, {ID: item.ID}, 'DELETE')
				} catch (err) {
						alert(`Der Gegenstand „${item.name}“ konnte nicht gelöscht werden.`)
				}
		}

		function pickup_item(e, item) {
				e.dataTransfer.setData('item/ID', item.ID)  }

</script>


<!-------------------------------- HTML -------------------------------------->

<section id={view.layout.page}>
<Sidebar items={[
	{id: 'create', help: 'additem', icon: 'plus', label: "Gegenstand hinzufügen", primary: true, onclick: add_item} ]}/>

<article class="page lootTable">
	<header class=lootHead>
		<div class=titleBox>
			<h2>Ausrüstung</h2>
			<span class=summary>{rewardItems.length} Gegenstände · {format_number(sum_of(rewardItems, 'weight'))} kg · Wert {format_number(sum_of(rewardItems, 'value'))}</span>
		</div>
		<div class=segToggle role=radiogroup aria-label="Darstellung">
			<button role=radio aria-checked={!grouped} class:active={!grouped} onclick={() => set_grouped(false)}>
				<span class="fa icon-list"></span>Liste
			</button>
			<button role=radio aria-checked={grouped} class:active={grouped} onclick={() => set_grouped(true)}>
				<span class="fa icon-table-cells"></span>Kategorien
			</button>
		</div>
	</header>

	{#if rewardItems.length === 0}
		<p class=empty>Für dieses Abenteuer sind noch keine Gegenstände als Belohnung angelegt.</p>
	{/if}

	{#each groups as group (group.label)}
		<div class=category>
			<h4>{group.label} <span class=count>{group.items.length}</span></h4>
			<div class=tableBox>
				<table>
					<thead>
						<tr>
							<th class=amount title="Anzahl">Anz</th>
							<th>Gegenstand</th>
							<th class=grade>Grad</th>
							<th>Besonderheiten</th>
							<th class=number title="Wert">Wert</th>
							<th class=number title="Gewicht in kg">Gew.</th>
							<th class=actions></th>
						</tr>
					</thead>
					<tbody>
						{#each group.items as item (item.ID)}
							<tr data-help="item" onclick={() => edit_item(item)} title={item.ID}>
								<td class="amount muted">{item.amount ?? 1}</td>
								<td draggable=true ondragstart={(e) => pickup_item(e, item)}>
									<div class=itemCell>
										<img class=typeIcon src={type_image(item.type)} alt={typeLabels[item.type] ?? ""}>
										<div>
											<span class=itemName>{item.name || "(ohne Namen)"}</span>
											{#if item.descript}<span class=descript>{item.descript}</span>{/if}
										</div>
									</div>
								</td>
								<td class=grade>{(item.grade > 0) ? item.grade : ""}</td>
								<td class="specials muted" title={perksToString(item.perks)}>{item.specials ?? ""}</td>
								<td class=number>{item.value ? format_number(item.value) : ""}</td>
								<td class=number>{item.weight ? `${format_number(item.weight)} kg` : ""}</td>
								<td class=actions>
									<button class="rowButton fa icon-pen" title="Gegenstand bearbeiten" aria-label="bearbeiten"
									        onclick={(e) => {e.stopPropagation(); edit_item(item)}}></button>
									<button class="rowButton delete fa icon-trash" title="Gegenstand löschen" aria-label="löschen"
									        onclick={(e) => delete_item(e, item)}></button>
								</td>
							</tr>
						{/each}
					</tbody>
					<tfoot>
						<tr>
							<td colspan=4 class=sumLabel>Summe</td>
							<td class=number>{format_number(sum_of(group.items, 'value'))}</td>
							<td class=number>{format_number(sum_of(group.items, 'weight'))} kg</td>
							<td></td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	{/each}

	<div class=rewardHint>
		<h4>Hinweis zur Belohnung</h4>
		<p>Der Lohn für das Bestehen des Abenteuers kann aus mehreren Teilen bestehen.
			Auf jeden Fall sollten die Charaktere Erfahrungspunkte (XP) bekommen. Je länger das Abenteuer war, desto mehr Erfahrung solltet ihr vergeben.
			Oftmals waren die Helden im Auftrag unterwegs und bekommen dafür Geld von ihrem Auftraggeber.
			Und zuletzt gibt es noch besondere Gegenstände, die die Helden im Abenteuer bekommen können (entweder als Schatz oder als Loot bei getöteten Feinden).</p>
	</div>
</article>
</section>


<style lang="sass">
	@use "../colors" as colors

	.lootHead
		display: flex
		flex-wrap: wrap
		align-items: flex-end
		justify-content: space-between
		gap: 12px 24px

	.titleBox
		display: flex
		flex-direction: column
		gap: 4px

		h2
			margin: 0
			font-size: 18px
			font-weight: 500

	.summary
		font-size: 13px
		color: colors.$grey-60

	.segToggle
		display: inline-flex
		border: 1px solid colors.$grey-30
		border-radius: 6px
		overflow: hidden

		button
			display: inline-flex
			align-items: center
			gap: 6px
			margin: 0
			padding: 5px 12px
			border: 0
			border-radius: 0
			background-color: transparent
			color: colors.$grey-60
			font-size: 13px
			cursor: pointer

			& + button
				border-left: 1px solid colors.$grey-30

			&:hover
				color: colors.$white
				background-color: colors.$grey-20

			&.active
				color: colors.$white
				background-color: colors.$primary-060-black

			&:focus-visible
				outline: 2px solid colors.$primary-100
				outline-offset: -2px

			.fa
				filter: none
				font-size: 12px

	.lootTable
		gap: 32px
		min-width: 0

	.rewardHint
		max-width: 72ch
		font-size: 13px
		line-height: 1.55
		color: colors.$grey-85

		h4
			margin: 0
			font-size: inherit
			color: colors.$primary-100

		p
			margin: 8px 0 0
			padding: 0
			font-size: 13px

	.empty
		color: colors.$grey-60
		font-style: italic

	.category
		display: flex
		flex-direction: column
		gap: 8px
		max-width: 1100px

	h4
		display: flex
		align-items: center
		gap: 12px
		margin: 0

	.count
		padding: 0 8px
		border-radius: 10px
		background-color: colors.$grey-20
		color: colors.$grey-85
		font-size: 12px
		font-weight: normal

	.tableBox
		overflow-x: auto

	table
		border-collapse: collapse

	th, td
		border: 0
		padding: 6px 8px
		vertical-align: top

	thead th
		border-bottom: 1px solid colors.$primary-100
		color: colors.$grey-60
		font-size: 12px
		font-weight: normal
		letter-spacing: 0.06em
		text-transform: uppercase
		text-align: left

	tbody tr
		border-bottom: 1px solid colors.$grey-20
		cursor: pointer

		&:hover
			background-color: colors.$primary-020

		&:hover .rowButton
			opacity: 1

	tfoot td
		padding: 8px
		font-weight: bold
		font-variant-numeric: tabular-nums

	.sumLabel
		font-size: 12px
		font-weight: normal
		letter-spacing: 0.08em
		text-transform: uppercase
		color: colors.$grey-60

	.amount
		width: 5ch
		text-align: center

	.grade
		width: 6ch
		text-align: center

	.number
		width: 10ch
		text-align: right
		white-space: nowrap
		font-variant-numeric: tabular-nums

	.muted
		color: colors.$grey-60

	.specials
		font-size: 13px

	.itemCell
		display: flex
		align-items: flex-start
		gap: 12px

		div
			display: flex
			flex-direction: column

	.typeIcon
		width: 20px
		height: 20px
		object-fit: contain

	.itemName
		font-weight: 500

	.descript
		font-size: 12px
		color: colors.$grey-60

	.actions
		width: 68px
		text-align: right
		white-space: nowrap

	.rowButton
		width: 30px
		height: 30px
		margin: 0 0 0 4px
		padding: 0
		border: 1px solid transparent
		border-radius: 6px
		background-color: transparent
		color: colors.$grey-60
		font-size: 13px
		filter: none
		opacity: 0.6
		cursor: pointer

		&:hover
			color: colors.$white
			background-color: colors.$grey-20

		&:focus-visible
			opacity: 1
			outline: 2px solid colors.$primary-100

		&.delete:hover
			color: colors.$white
			background-color: colors.$highlight-red-060-black

</style>
